 // helpers
function normalizeKeyBytes(keyString) {
  const enc = new TextEncoder();
  const src = enc.encode(keyString);
  const keyBytes = new Uint8Array(32); // AES-256
  keyBytes.set(src.slice(0, 32)); // corta se maior, preenche com zeros se menor
  return keyBytes;
}

function arrayBufferToBase64(buffer) {
  // buffer pode ser ArrayBuffer ou Uint8Array
  const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer);
  // converte em string binária em chunks para evitar estourar argumentos
  const CHUNK = 0x8000;
  let binary = '';
  for (let i = 0; i < bytes.length; i += CHUNK) {
    const slice = bytes.subarray(i, i + CHUNK);
    binary += String.fromCharCode.apply(null, slice);
  }
  return btoa(binary);
}


export const cryptRequest = async (plainObject, keyString) => {
  const enc = new TextEncoder();

  // 1) normaliza e importa a chave (AES-256-GCM)
  const keyBytes = normalizeKeyBytes(keyString);
  const aesKey = await crypto.subtle.importKey(
    'raw',
    keyBytes,
    { name: 'AES-GCM' },
    false,
    ['encrypt']
  );

  // 2) gera IV (12 bytes)
  const iv = crypto.getRandomValues(new Uint8Array(12));

  // 3) transforma object em bytes
  const plainBytes = enc.encode(JSON.stringify(plainObject));

  // 4) criptografa (resultado inclui tag no final quando usado WebCrypto)
  const cipherBuffer = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    aesKey,
    plainBytes
  );

  const cipherBytes = new Uint8Array(cipherBuffer); // ciphertext + tag

  // 5) codifica em Base64
  const encryptedBase64 = arrayBufferToBase64(cipherBytes);
  const ivBase64 = arrayBufferToBase64(iv);

  // 6) retorna objeto pronto pra enviar ao backend (Delphi)
  return {
    encrypted: true,
    data: encryptedBase64, // Delphi espera ciphertext+tag em base64
    iv: ivBase64
  };
}